import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';

import { BlockUI } from 'primereact/blockui';
import { Menubar } from 'primereact/menubar';
import PerformanceCheckReport from '../../components/PerformanceCheck/PerformanceCheckReport';
import { ServiceProvider } from '../../services';
import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useReactToPrint } from 'react-to-print';

const performanceCheckService = ServiceProvider.performanceCheck;

const PerformanceCheckViewer = ({
  match: {
    params: { statementNumber, dataId },
  },
}) => {
  const reportRef = useRef(null);
  const hiddenWrappersRef = useRef([]);
  const hiddenContainersRef = useRef([]);
  const pageBreakAdjustedRef = useRef([]);
  const searchParams = new URLSearchParams(window.location.search);
  const docType = searchParams.get('docType');

  const isInsurancePaper = (paper) =>
    !!paper.querySelector(
      'img[alt^="insurance_certificate_"], img[alt^="ew_insurance_certificate_"]'
    );

  const getTargetPapers = () => {
    const papers = Array.from(
      reportRef.current?.querySelectorAll('.paper') ?? []
    );
    if (docType === 'insurance') return papers.filter((p) => isInsurancePaper(p));
    if (docType === 'performance') return papers.filter((p) => !isInsurancePaper(p));
    return papers;
  };

  const hideNonTargetPapers = () => {
    hiddenWrappersRef.current = [];
    hiddenContainersRef.current = [];
    pageBreakAdjustedRef.current = [];
    if (!reportRef.current || !['insurance', 'performance'].includes(docType)) {
      return;
    }
    const containers = Array.from(
      reportRef.current.querySelectorAll('.paper_container')
    );
    containers.forEach((container) => {
      const papers = Array.from(container.querySelectorAll('.paper'));
      const wrappers = Array.from(container.querySelectorAll('.paper_wrapper'));
      const hasTargetPaper = papers.some((paper) =>
        docType === 'insurance' ? isInsurancePaper(paper) : !isInsurancePaper(paper)
      );

      if (!hasTargetPaper) {
        hiddenContainersRef.current.push(container);
        container.style.display = 'none';
        return;
      }

      wrappers.forEach((wrapper) => {
        const paper = wrapper.querySelector('.paper');
        if (!paper) return;
        const isTarget =
          docType === 'insurance'
            ? isInsurancePaper(paper)
            : !isInsurancePaper(paper);
        if (!isTarget) {
          hiddenWrappersRef.current.push(wrapper);
          wrapper.style.display = 'none';
        }
      });
    });

    const visibleWrappers = Array.from(
      reportRef.current.querySelectorAll('.paper_wrapper')
    ).filter((wrapper) => wrapper.style.display !== 'none');

    if (visibleWrappers.length > 0) {
      const lastWrapper = visibleWrappers[visibleWrappers.length - 1];
      pageBreakAdjustedRef.current.push({
        element: lastWrapper,
        pageBreakAfter: lastWrapper.style.pageBreakAfter,
        breakAfter: lastWrapper.style.breakAfter,
      });
      lastWrapper.style.pageBreakAfter = 'auto';
      lastWrapper.style.breakAfter = 'auto';
    }
  };

  const restoreHiddenPapers = () => {
    pageBreakAdjustedRef.current.forEach(({ element, pageBreakAfter, breakAfter }) => {
      element.style.pageBreakAfter = pageBreakAfter;
      element.style.breakAfter = breakAfter;
    });
    pageBreakAdjustedRef.current = [];

    hiddenContainersRef.current.forEach((container) => {
      container.style.display = '';
    });
    hiddenContainersRef.current = [];
    hiddenWrappersRef.current.forEach((wrapper) => {
      wrapper.style.display = '';
    });
    hiddenWrappersRef.current = [];
  };

  const [loading, setLoading] = useState(false);
  const [checkData, setCheckData] = useState(null);
  const [checkPhotos, setCheckPhotos] = useState(null);
  const [data, setData] = useState({
    paymentInformation: null,
    association: null,
    inspector: null,
    vehicleInformation: null,
    customerCompany: null,
  });
  const viewerTitle =
    docType === 'insurance' ? '보험증명서' : '성능점검기록부';

  const handlePrint = useReactToPrint({
    content: () => {
      const paperWrapper = reportRef.current.querySelectorAll('.paper_wrapper');

      console.log(paperWrapper);

      // if (paperWrapper.length > 0) {
      //   paperWrapper.forEach((wrapper) => {
      //     wrapper.style.width = '210mm';
      //     wrapper.style.height = '297mm';
      //     wrapper.style.minHeight = '297mm';
      //     wrapper.style.border = 'initial';
      //     wrapper.style.borderRadius = 'initial';
      //     wrapper.style.boxShadow = 'initial';
      //     wrapper.style.background = 'initial';
      //     wrapper.style.pageBreakAfter = 'initial';
      //   });
      // }

      hideNonTargetPapers();
      const papers = getTargetPapers();
      if (papers.length === 0) {
        restoreHiddenPapers();
        return false;
      }

      const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
      for (let i = 0; i < papers.length; i++) {
        const page = papers[i];

        // page.style.transform = 'rotate(90deg)';
        // page.style.width = `148.5mm`;
        // page.style.height = '210mm';
        // page.style.minHeight = '210mm';
        // page.style.pageBreakAfter = 'avoid';

        const parts = page.querySelectorAll('.cerp-pp');
        for (let j = 0; j < parts.length; j++) {
          const part = parts[j];
          part.style.fontSize = '1rem';
        }

        const watermark = buildWatermark(now);
        page.appendChild(watermark);
      }

      return reportRef.current;
    },
    pageStyle: `
    @page {
        size: A4 landscape;
        margin: 0 !important;
        padding: 0 !important;
      }
      
    html,
    body {
    width: 297mm;
    height: 210mm;
    background: #ffffff;
    margin: 0 !important;
    padding: 0 !important;
    color: black;
  }
    `,
    onBeforePrint: async () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      const watermarks = reportRef.current.querySelectorAll('.cerp-watermark');
      _.map(watermarks, (watermark) => watermark.remove());

      const parts = reportRef.current.querySelectorAll('.cerp-pp');
      _.map(parts, (part) => (part.style.fontSize = '1.25rem'));

      restoreHiddenPapers();
      setLoading(false);
    },
  });

  const handlePDF = async () => {
    setLoading(true);
    const papers = getTargetPapers();
    if (papers.length === 0) {
      window.cerp.dialog.error('출력 실패', '출력할 문서가 없습니다.');
      setLoading(false);
      return false;
    }

    const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
    const pageImages = [];
    const reportPDF = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true,
    });

    for (let i = 0; i < papers.length; i++) {
      const page = papers[i];
      const watermark = buildWatermark(now);
      page.appendChild(watermark);

      const canvas = await html2canvas(page, {
        scale: 2,
        logging: true,
        allowTaint: true,
        useCORS: true,
        imageTimeout: 0,
        backgroundColor: 'transparent',
      });

      const pageImage = canvas.toDataURL('image/png');
      pageImages.push(pageImage);
      page.removeChild(watermark);
    }

    for (let i = 0; i < pageImages.length; i++) {
      reportPDF.addImage(
        pageImages[i],
        'PNG',
        0,
        0,
        210,
        297,
        `PAGE-${i}`,
        'NONE',
        0
      );
      if (i < pageImages.length - 1) reportPDF.addPage();
    }

    const filePrefix = docType === 'insurance' ? '보험증명서' : '성능점검기록부';
    reportPDF.save(`${filePrefix}_${statementNumber}.pdf`);
    setLoading(false);
  };

  const buildWatermark = (now) => {
    const watermark = document.createElement('div');
    _.map(
      _.split(
        'cerp-watermark absolute top-50 left-0 right-0 opacity-40 text-gray-500 font-bold p-4rem text-center text-4xl origin-center',
        ' '
      ),
      (cls) => watermark.classList.add(cls)
    );
    watermark.style.transform = 'rotate(-30deg)';
    const text = document.createTextNode(`출력일시 : ${now}`);
    watermark.appendChild(text);

    return watermark;
  };

  useEffect(() => {
    setLoading(true);

    (async () => {
      const { data, error } = await performanceCheckService.getData(
        // statementNumber
        dataId
      );

      if (data) {
        const {
          performanceCheckData: {
            checkData: checkDataRaw,
            paymentInformation: paymentInformationRaw,
            association: associationRaw,
            inspector: inspectorRaw,
            customerCompany: customerCompanyRaw,
            vehicleInformation: vehicleInformationRaw,
          },
          performanceCheckPhotos,
        } = data;

        const checkData = JSON.parse(checkDataRaw);
        const paymentInformation = JSON.parse(paymentInformationRaw);
        const association = JSON.parse(associationRaw);
        const inspector = JSON.parse(inspectorRaw);
        const customerCompany = JSON.parse(customerCompanyRaw);
        const vehicleInformation = JSON.parse(vehicleInformationRaw);

        setCheckData(checkData);
        setCheckPhotos(performanceCheckPhotos);
        setData((ps) => ({
          ...ps,
          paymentInformation,
          association,
          inspector,
          vehicleInformation,
          customerCompany,
        }));
      }

      if (error) {
        window.cerp.dialog.error(
          '존재하지 않는 성능지번호 입니다.',
          `[${statementNumber}]`
        );
      }
    })();

    setLoading(false);
  }, [dataId, statementNumber]);

  useEffect(() => {
    if (!checkData) return;
    if (!['insurance', 'performance'].includes(docType)) {
      restoreHiddenPapers();
      return;
    }
    // Report 렌더링 후 화면에서도 해당 문서만 보이게 처리
    const id = requestAnimationFrame(() => {
      hideNonTargetPapers();
    });
    return () => cancelAnimationFrame(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkData, docType]);

  return (
    <div className="pcr_wrapper">
      <BlockUI
        fullScreen
        blocked={loading}
        template={
          loading && (
            <i className="pi pi-spin pi-spinner text-white-alpha-90 font-bold text-6xl" />
          )
        }
      >
        <Menubar
          className="sticky top-0 z-1"
          model={[
            {
              label: '출력하기',
              icon: 'pi pi-fw pi-print',
              command: handlePrint,
            },
            {
              label: 'PDF 다운로드',
              icon: 'pi pi-fw pi-download',
              command: handlePDF,
            },
          ]}
          start={
            <label className="text-2xl font-semibold mr-2">
              {viewerTitle}
            </label>
          }
        />
        <div className="flex flex-row align-items-center justify-content-center py-3">
          {checkData && (
            <PerformanceCheckReport
              ref={reportRef}
              data={checkData}
              photos={checkPhotos}
              payment={_.get(data, 'paymentInformation')}
              association={_.get(data, 'association')}
              inspector={_.get(data, 'inspector')}
              customerCompany={_.get(data, 'customerCompany')}
              vehicleInformation={_.get(data, 'vehicleInformation')}
              documentType={docType}
            />
          )}
        </div>
      </BlockUI>
      {/*{_.map(reportCaptureData, data => (<img src={data} style={{width: '210mm'}} />))}*/}
    </div>
  );
};

export default PerformanceCheckViewer;
